module.exports = __webpack_public_path__ + "static/media/131-water drop.07624b88.svg";